global.getNameTicketType = function (name) {
    let type = "";
    switch (name) {
        case "HOURLY":
            type = "Orario";
            break;
        case "DAILY":
            type = "Giornaliero";
            break;
        case "TWODAYS":
            type = "Bigiornaliero";
            break;
        case "THREEDAYS":
            type = "Tre giorni";
            break;
        case "FOURDAYS":
            type = "Quattro giorni";
            break;
        case "WEEKDAYS":
            type = "Cinque giorni";
            break;
        case "WEEKLY":
            type = "Settimanale";
            break;
        case "TWOWEEKS":
            type = "Bisettimanale";
            break;
        case "MONTHLY":
            type = "Mensile";
            break;
        case "TRIMESTER":
            type = "Trimestrale";
            break;
        case "SEASONAL":
            type = "Stagionale";
            break;
        case "SEMIANNUAL":
            type = "Semestrale";
            break;
        case "YEARLY":
            type = "Annuale";
            break;
        case "BIANNUAL":
            type = "Biennale";
            break;
        case "TRIENNIAL":
            type = "Triennale";
            break;
    }
    return type;
}